import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Driver } from 'src/app/core/models/driver';
import { User } from 'src/app/core/interfaces/user';
import { Permission } from 'src/app/core/resources/permission';
import { AdminUsersService } from '../admin-users/admin-users.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ChangePhoneDialogComponent } from '../change-phone-dialog/change-phone-dialog.component';
import { ManualAcceptComponent } from './manual-accept/manual-accept.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { LegalTermsService } from '../legal-terms/legal-terms.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Utils } from 'src/app/core/resources/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-request-terms-dialog',
  templateUrl: './request-terms-dialog.component.html',
  styleUrls: ['./request-terms-dialog.component.scss']
})
export class RequestTermsDialogComponent implements OnInit {
  permission = Permission;

  constructor(
    public spinner: NgxSpinnerService,
    private termsAndConditionsService: LegalTermsService,
    public dialogRef: MatDialogRef<RequestTermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { name: string, document: string, phone: string, user: Driver | any },
    private adminUsersService: AdminUsersService,
    private snackbarService: SnackBarService,
    private authService: AuthService,
    private dialog: MatDialog,
    private utils: Utils
  ) { }

  ngOnInit() {
  }

  get legalDocumentsInvalid(): string[] {
    const legalDocumentsInvalid = [];
    if (this.data.user && ((this.data.user.lastPersonalDataPolicy && !this.data.user.lastPersonalDataPolicy.state) || !this.data.user.lastPersonalDataPolicy)) {
      legalDocumentsInvalid.push('Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales Teclogi Cargo');
    }
    if (this.data.user && ((this.data.user.manifestBindingContract && !this.data.user.manifestBindingContract.state) || !this.data.user.manifestBindingContract) && this.isTeclogiUser) {
      legalDocumentsInvalid.push('Contrato de vinculación Teclogi Cargo');
    }
    if (this.data.user && ((this.data.user.personalDataPolicyLogistics && !this.data.user.personalDataPolicyLogistics.state) || !this.data.user.personalDataPolicyLogistics) && this.isTeclogiUser) {
      legalDocumentsInvalid.push('Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales Teclogi Logistics');
    }
    if (this.data.user && ((this.data.user.manifestBindingContractLogistics && !this.data.user.manifestBindingContractLogistics.state) || !this.data.user.manifestBindingContractLogistics) && this.isTeclogiUser) {
      legalDocumentsInvalid.push('Contrato de vinculación Teclogi Logistics');
    }
    if (this.data.user && ((this.data.user.lastPrivacyPolicies && !this.data.user.lastPrivacyPolicies.state) || !this.data.user.lastPrivacyPolicies)) {
      legalDocumentsInvalid.push('Aviso de Privacidad y Autorización para el Tratamiento de Datos Personales LoggiApp');
    }
    if (this.data.user && ((this.data.user.lastUserTerm && !this.data.user.lastUserTerm.state) || !this.data.user.lastUserTerm)) {
      legalDocumentsInvalid.push('Términos y condiciones LoggiApp');
    }
    if (this.data.user && ((this.data.user.factoringContractLoggiFintech && !this.data.user.factoringContractLoggiFintech.state) || !this.data.user.factoringContractLoggiFintech) && this.isTeclogiUser) {
      legalDocumentsInvalid.push('Contrato de Fáctoring comercial');
    }
    return legalDocumentsInvalid;
  }

  submit() {
    const user = this.data.user;
    if (!user || !user.information) {
      this.snackbarService.openSnackBar("No se ha podido leer la información del usuario.", "Aceptar", "error");
      return;
    }
    this.spinner.show();
    this.termsAndConditionsService
      .requestTermsAndPoliciesAcceptance(
        user.information.document,
        user.information.name,
        `57${this.data.phone}`,
        this.authService.getCompanySaaS().companyId,
        this.authService.getCompanySaaS().name
      ).subscribe(
        () => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(`Se ha enviado la petición de políticas correctamente al +57 ${this.data.phone}`, undefined, "success");
          this.dialogRef.close();
        },
        () => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(`Ocurrió un error al enviar las políticas al +57 ${this.data.phone}`, undefined, "error");
        }
      );
  }

  copyDriverRegistration() {
    navigator.clipboard.writeText(this.termsAndConditionsService.getDriverRegistrationUrl(this.authService.getCompanySaaS().companyId));
    this.snackbarService.openSnackBar('Enlace de aceptación de términos y condiciones copiado al portapapeles');
  }

  sendMessageToWhatsapp() {
    const phone: string = this.utils.clone(this.data.phone).slice(-10);
    const name = this.utils.getNestedValue(this.data, 'user.information.name');
    const message = this.termsAndConditionsService.getSMSMessage(name, this.authService.getCompanySaaS().name, this.authService.getCompanySaaS().companyId);
    const wppLink = `https://wa.me/57${phone}?text=${encodeURIComponent(message)}`;
    window.open(wppLink, '_blank');
  }

  changePhone() {
    this.dialog
      .open(ChangePhoneDialogComponent)
      .afterClosed()
      .subscribe(
        (phone) => {
          if (phone) {
            phone = phone.slice(-10);
            phone = `57${phone}`;
            this.data.user.phone = phone;
            // Solo lo que cambia: el usuario completo trae el state sobreescrito por los estados de activación de la empresa.
            const user: User = { information: { document: this.data.user.information.document }, phone };
            this.adminUsersService.updateUser(user).subscribe(
              () => {
                this.data.phone = phone.slice(2);
                this.snackbarService.openSnackBar('Se ha actualizado el número de teléfono del usuario.', 'Aceptar', "success");
              },
              () => {
                this.snackbarService.openSnackBar('Ha ocurrido un error actualizando el número de teléfono del usuario.', 'Aceptar', "error")
              }
            );
          }
        }
      );
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }

}
